module.exports = __webpack_public_path__ + "img/icons8-list-ahb.557aaac2.svg";